import NavbarData from "../../Components/Nav/NavbarModel/NavbarData";
import NavbarItem from "../../Components/Nav/NavbarModel/NavbarItem";


const ENV=process.env.REACT_APP_ENV;
const CMS_API_URL=process.env.REACT_APP_CMS_API_URL;

export default class NavbarService
{
    constructor()
    {
       
    }

    /** @returns {Promise<NavbarData>} */
    async getNavbarData()
    {
        let navbarData = new NavbarData();
        navbarData.LogoName = "Knowledge Buddy";
        navbarData.LogoLinkTo = "/";
        navbarData.NavbarItems = [];
     

        try
        {
          
          
            const response = await fetch(`https://cms.knowledgebuddy.in/api/Navigation/GetNavigation`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const result = await response.json();
            if (result.status === "success" && result.data && Array.isArray(result.data)) {
                // Populate navbar items from API response
                result.data.forEach(item => {
                    navbarData.NavbarItems.push(new NavbarItem(
                        item.name,
                        item.url,
                        item.icon,
                        item.description,
                        item.isActive,
                        item.index
                    ));
                });
            } else {

                console.warn("API returned invalid data, using fallback navigation items");
               // this.addFallbackNavbarItems(navbarData);
            }


        }catch(error)
        {

        }
        return navbarData
    }

    addFallbackNavbarItems(navbarData) {
        navbarData.NavbarItems.push(new NavbarItem("Home", "/"));
        navbarData.NavbarItems.push(new NavbarItem("Tutorials", "/tutorial"));
        navbarData.NavbarItems.push(new NavbarItem("About", "/aboutus"));
        navbarData.NavbarItems.push(new NavbarItem("Contact", "/contactus"));
    }
}